import { StyleSheet } from 'react-native';
import colors from '@alucio/lux-ui/src/theming/themes/alucio/colors';

const styles = StyleSheet.create({
  tintOverlay: {
    backgroundColor: colors['color-text-white'],
    opacity: 0.5,
  },
});

export const thumbnailTintOverlayStyle = [
  StyleSheet.absoluteFillObject,
  styles.tintOverlay,
];
